import { AppTheme, AppThemeBundle, AppThemeKey, getAppTheme } from "@/themes/theme.types.ts";
import { createContext, useContext, useMemo } from "react";

export interface AppContextProps {
  theme: AppThemeBundle;
}

export const AppContext = createContext<AppContextProps>({
  theme: getAppTheme("default"),
});

export function useAppContext() {
  const context = useContext(AppContext);

  if (context === undefined) {
    throw new Error("useAppContext must be used within a AppContext");
  }
  return context;
}

export function useAppTheme<T extends AppThemeKey>(key: T): AppTheme[T] {
  const context = useAppContext();
  return useMemo(() => {
    const theme = context.theme.appTheme[key];
    return theme as AppTheme[T];
  }, [key, context]);
}
